import * as Yup from "yup";

export const CustomDisclosureSchema = Yup.object({
  category: Yup.string().required("Category is required"),
  code: Yup.string().required("Code is required"),
  title: Yup.string().required("Title is required"),
});

export const DelegationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid email")
    .required("Email is required"),
  message: Yup.string(),
});
